import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminLayout } from "@/components/AdminLayout";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import HomePage from "@/pages/HomePage";
import PaymentResult from "@/pages/PaymentResult";
import StudentDashboard from "@/pages/StudentDashboard";
import TestRunner from "@/pages/TestRunner";
import ResultPage from "@/pages/ResultPage";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminTests from "@/pages/admin/AdminTests";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminResults from "@/pages/admin/AdminResults";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminToppers from "@/pages/admin/AdminToppers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminPasswordTickets from "@/pages/admin/AdminPasswordTickets";

const Home = () => {
  const { user } = useAuth();
  if (user === null) return null;
  return <HomePage />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/payment-result" element={<ProtectedRoute role="student"><PaymentResult /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute role="student"><StudentDashboard /></ProtectedRoute>} />
          <Route path="/test/:attemptId" element={<ProtectedRoute role="student"><TestRunner /></ProtectedRoute>} />
          <Route path="/result/:attemptId" element={<ProtectedRoute role="student"><ResultPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminOverview />} />
            <Route path="tests" element={<AdminTests />} />
            <Route path="tests/:testId" element={<AdminQuestions />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="toppers" element={<AdminToppers />} />
            <Route path="students" element={<AdminStudents />} />
            <Route path="tickets" element={<AdminPasswordTickets />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="results" element={<AdminResults />} />
            <Route path="results/:attemptId" element={<ResultPage admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
